export default class NullUserStore {
  patient = {};

  isHydrated: false = false;

  get() {
    return null;
  }
}
